import BuoyClient from 'lib/BuoyClient';

import {
  SubmitBusinessOnboardingFormAction,
  SubmitGeneralInquiryAction,
} from 'state/actions/types/formActionsTypes';

import { FormValues } from 'types';

export const submitBusinessOnboardingForm = (
  form: FormValues,
  formLeadSource?: string,
  formLeadSourceOtherC?: string
): SubmitBusinessOnboardingFormAction => {
  return {
    type: 'SUBMIT_BUSINESS_ONBOARDING_FORM',
    payload: BuoyClient.postWebToLeadForm(
      form,
      formLeadSource,
      formLeadSourceOtherC
    ),
  };
};

export const submitGeneralInquiry = (
  form: FormValues
): SubmitGeneralInquiryAction => {
  return {
    type: 'SUBMIT_GENERAL_INQUIRY',
    payload: BuoyClient.postGeneralInquiry(form),
  };
};
